export default __webpack_public_path__ + "static/media/testimonial-3.32bbed40.png";